import Vue from 'vue';
import Router from 'vue-router';
import TweenMax from 'gsap/TweenMax';

import Home from './views/Home.vue';
import AppPage from './views/AppPage.vue';
import store from './store';


Vue.use(Router);

let firstEnter = true;
const router = new Router({
  mode: 'history',

  base: process.env.BASE_URL,

  routes: [
    {
      path: '/:lang(it|en)',
      name: 'home',
      component: Home,
    },
    {
      path: '/',
      redirect: '/it',
    },
    {
      path: '/:page(polistirene|chi-siamo|produzione|contatti|polystyrene|about-us|production|contact)',
      name: 'page',
      component: AppPage,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    to.path !== '/it'
    && to.path !== '/polistirene'
    && to.path !== '/chi-siamo'
    && to.path !== '/produzione'
    && to.path !== '/contatti'
    && firstEnter
  ) {
    firstEnter = false;
    store.commit('CHANGE_LANG', 'en');
  }

  if (from.path !== '/it' && from.path !== '/en') {
    TweenMax.to('.app__container', 0.6, {
      y: -200,
    });
    TweenMax.to('#app', 0.6, {
      autoAlpha: 0,
      onComplete: () => {
        store.dispatch('fetchData', to).then(next);
        TweenMax.set('.app__container', { y: 0 });
        TweenMax.to('#app', 0.4, { autoAlpha: 1 });
      },
    });
  } else {
    store.dispatch('fetchData', to).then(next);
  }
});

export default router;
